/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
/* eslint-disable react/no-array-index-key */
import React from 'react';
import { GoogleApiWrapper } from 'google-maps-react';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import Grid from '@mui/material/Grid';
import { makeStyles } from '@mui/styles';
import throttle from 'lodash/throttle';
import TextField from '../TextField';
import Typography from '../Typography';
import { useTranslation } from '../../../config/i18n';

import Autocomplete from '../../molecules/Autocomplete';
import { GOOGLE_MAP_KEY } from '../../../constants';

const autocompleteService = { current: null };

const useStyles = makeStyles(theme => ({
  icon: {
    color: theme.palette.text.secondary,
    marginRight: theme.spacing(2),
  },
}));

const LocationTextField = ({
  onChange,
  name,
  value,
  label,
  google,
  error,
  disabled,
  helperText,
  onBlur,
  multiple,
  types
}) => {
  const classes = useStyles();
  const [inputValue, setInputValue] = React.useState('');

  const [options, setOptions] = React.useState([]);


  const { t } = useTranslation(['common']);

  const fetch = React.useMemo(
    () =>
      throttle((request, callback) => {
        // console.log('Request -=====>', request);
        autocompleteService.current.getPlacePredictions(request, callback);
      }, 200),
    []
  );

  function onChangeHandler(event, newValue) {
    setOptions(newValue ? [newValue, ...options] : options);
    onChange.call(this, event, newValue);
  }

  React.useEffect(() => {
    let active = true;

    if (!autocompleteService.current && google) {
      autocompleteService.current = new google.maps.places.AutocompleteService();
    }
    if (!autocompleteService.current) {
      return undefined;
    }

    if (inputValue === '') {
      setOptions(value ? [value] : []);
      return undefined;
    }

    fetch(
      {
        input: inputValue,
        options: {
          fields: ['description', 'place_id', 'structured_formatting'],
          types: [...types]
        },
      },
      results => {
        if (active) {
          let newOptions = [];

          if (value) {
            newOptions = [value];
          }

          if (results) {
            newOptions = [...newOptions, ...results];
          }

          setOptions(newOptions);
        }
      }
    );

    return () => {
      active = false;
    };
  }, [value, inputValue, fetch]);
  // console.log(value, "VALUE")

  return (
    <Autocomplete
      id={name}
      name={name}
      disabled={disabled}
      //   style={{ width: 300 }}
      getOptionLabel={(option) => (typeof option === 'string' ? option : option.description)}
      options={options}
      autoComplete
      includeInputInList
      filterSelectedOptions
      value={value}
      noOptionsText={t('common:search_location')}
      onChange={onChangeHandler}
      multiple={multiple}
      onInputChange={(event, newInputValue) => {
        setInputValue(newInputValue);
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          disabled={disabled}
          //   variant="outlined"
          name={name}
          onBlur={onBlur}
          error={error}
          helperText={helperText}
          fullWidth
        />
      )}
    // renderOption={(option) => {
    //   if (!option || !option.structured_formatting) {
    //     return '';
    //   }
    //   const matches =
    //     option.structured_formatting && option.structured_formatting.main_text_matched_substrings;
    //   const parts = parse(
    //     option.structured_formatting.main_text,
    //     matches.map((match) => [match.offset, match.offset + match.length])
    //   );

    //   return (
    //     <Grid container alignItems="center">
    //       <Grid item>
    //         <LocationOnIcon className={classes.icon} />
    //       </Grid>
    //       <Grid item xs>
    //         {parts.map((part, index) => (
    //           <span key={index} style={{ fontWeight: part.highlight ? 700 : 400 }}>
    //             {part.text}
    //           </span>
    //         ))}

    //         <Typography variant="body2" color="textSecondary">
    //           {option.structured_formatting.secondary_text}
    //         </Typography>
    //       </Grid>
    //     </Grid>
    //   );
    // }}
    />
  );
};

LocationTextField.defaultProps = {
  types: []
}

export default GoogleApiWrapper({
  apiKey: GOOGLE_MAP_KEY,
  libraries: ['places'],
})(LocationTextField);
